import { DesignData, MediaElement } from 'editor/src/store/design/types';
import { getAdvPersoDataFromElement } from 'editor/src/store/plugins/utils/advPersoUtils';

import { getLinkedCollectionElements } from './collectionLink';

// A rename clashes only with elements outside the renamed element's link group:
// linked layers deliberately share one name. Scope matches the historical rule —
// first page of each spread.
function hasElementNameClash(designData: DesignData, element: MediaElement, name: string): boolean {
  const linkGroupId = getAdvPersoDataFromElement(element)?.linkGroupId;
  const linkedElements = linkGroupId ? getLinkedCollectionElements(designData, linkGroupId) : [];
  const isOwnOrLinked = (uuid: number) =>
    uuid === element.uuid || linkedElements.some((linked) => linked.element.uuid === uuid);

  return designData.spreads.some((spread) =>
    spread.pages[0].groups.media?.some((other) => other.name === name && !isOwnOrLinked(other.uuid)),
  );
}

export default hasElementNameClash;
